<!-- 获取时间段出场记录接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"2KNTYVWC","carNoArray":["粤YAL876","粤A66666"],"startTime":"20150115141333","endTime":"20171015141333","pageNum":"1","pageSize":"2"},
            responseCode: 	{"data":{"currCount":2,"recordList":[{"billList":[null],"carCode":"未识别0726101308989","cardCode":"","enterAddress":"","enterDate":"20170726101308","enterImageArray":[],"enterOperator":"","enterType":0,"enterVipType":1,"outAddress":"开发出口","outDate":"20170726101308","outImageArray":[],"outOperateTime":"20170726101333","outOperator":"yz","outType":3,"outVipType":1,"parkCode":"2KNTYVWC","parkName":"开发停车场2","parkingCode":"2017072610130804931865","totalFavorFee":0.00,"totalParkFee":0.00,"totalPayFee":0.00},{"billList":[null],"carCode":"未识别0726102430196","cardCode":"","enterAddress":"","enterDate":"20170726102430","enterImageArray":[],"enterOperator":"","enterType":0,"enterVipType":1,"outAddress":"开发出口","outDate":"20170726102430","outImageArray":[],"outOperator":"","outType":0,"outVipType":1,"parkCode":"2KNTYVWC","parkName":"开发停车场2","parkingCode":"2017072610243004956558","totalFavorFee":0.00,"totalParkFee":0.00,"totalPayFee":0.00}],"total":216},"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取指定车辆指定时间段停车记录信息（车辆驶出停车场后该接口才能查询到数据）",
                t_url: this.commonUrls.test+"getHisParkDetail",
                p_url: this.commonUrls.prod+"getHisParkDetail",
                precondition: "车辆驶出停车场后该接口才能查询到数据",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carNoArray', info2: '否', info3: 'String[]', info4: '车牌号数组，如["粤YAL123","粤WKL345"]' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号' },
                        { info1: 'cardCode', info2: '否', info3: 'String', info4: '停车卡编号' },
                        { info1: 'enterDate', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'enterImageArray', info2: '是', info3: 'JSONArray', info4: '进场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'enterAddress', info2: '是', info3: 'String', info4: '进场通道名' },
                        { info1: 'enterType', info2: '是', info3: 'Integer', info4: '进场放行类型，0未确认，1自动放行，2确认放行，3异常放行' },
                        { info1: 'enterVipType', info2: '是', info3: 'Integer', info4: '进场VIP类型，0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客' },
                        { info1: 'enterOperator', info2: '是', info3: 'String', info4: '进场放行操作员' },
                        { info1: 'enterOperateTime', info2: '是', info3: 'String', info4: '进场放行时间，yyyyMMddHHmmss' },
                        { info1: 'outDate', info2: '是', info3: 'String', info4: '出场时间，yyyyMMddHHmmss' },
                        { info1: 'outImageArray', info2: '是', info3: 'JSONArray', info4: '出场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'outAddress', info2: '是', info3: 'String', info4: '出场通道名' },
                        { info1: 'outType', info2: '是', info3: 'Integer', info4: '出场放行类型，0未确认，1自动放行，2确认放行，3异常放行' },
                        { info1: 'outVipType', info2: '是', info3: 'Integer', info4: '出场VIP类型，0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客' },
                        { info1: 'outOperator', info2: '是', info3: 'String', info4: '出场放行操作员' },
                        { info1: 'outOperateTime', info2: '是', info3: 'String', info4: '出场放行时间，yyyyMMddHHmmss' },
                        { info1: 'totalParkFee', info2: '是', info3: 'Decimal', info4: '总停车费用' },
                        { info1: 'totalFavorFee', info2: '是', info3: 'Decimal', info4: '总优惠费用' },
                        { info1: 'totalPayFee', info2: '是', info3: 'Decimal', info4: '总支付费用' },
                        { info1: 'billList', info2: '是', info3: 'JSONArray', info4: '支付账单信息列表' }
                        ]
                },{
                    titleName: 'billList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'payValue', info2: '是', info3: 'Decimal', info4: '支付金额' },
                        { info1: 'disValue', info2: '否', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方系统缴费订单号' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源，参考附录' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'String', info4: '支付方式，参考附录' },
                        { info1: 'paymentModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/parking/getHisParkDetail.vue